import api from './api';

export const getCustomDomains = (page, params) => {
  return api.get('admin/CustomDomain', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getCustomDomainsBySearch = (searchItem, search) => {
  return api.get(`admin/CustomDomain?searchItem=${searchItem}&search=${search}`);
};

export const updateCustomDomain = (customDomainId, update) => {
  return api.put(`admin/CustomDomain/item/${customDomainId}`, { object: update });
};
